import React, { useEffect } from 'react';
import {
  View, Image, TextInput, ScrollView,
} from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';
import { useDispatch, useSelector } from 'react-redux';

import logo_purple from '../../../assets/images/logo_purple.png';
import { AppHeader } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { UserActions } from '../../../redux/reducers/userReducer';
import { styles } from './styles';

const SignUpGroup = ({ navigation }) => {
  const { userSignUp } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: UserActions.UPDATE_SIGNUP,
      userSignUp: {
        ...userSignUp, nome2: '', nome3: '', nome4: '', email2: '', email3: '', email4: '',
      },
    });
  }, []);
  const verifyBlanks = () => {
    const {
      nome2, nome3, nome4, email2, email3, email4,
    } = userSignUp;
    if (userSignUp.group_qnt > 1 && userSignUp.group_qnt < 3) {
      return nome2 === '' || email2 === '';
    } if (userSignUp.group_qnt > 2 && userSignUp.group_qnt < 4) {
      return nome2 === '' || email2 === '' || nome3 === '' || email3 === '';
    }
    return nome2 === '' || email2 === '' || nome3 === '' || email3 === '' || nome4 === '' || email4 === '';
  };
  return (
    <>
      <AppHeader navigation={navigation} hasBack title="Cadastro Grupo" />
      <ScrollView style={styles.card}>
        <Image style={styles.logo} source={logo_purple} />
        <AppText size="bold" style={styles.textTitle}>Informe seus Amigos</AppText>
        <View style={styles.viewForm}>
          {userSignUp.group_qnt > 1 && (
            <>
              <AppText>Primeiro: </AppText>
              <View>
                <TextInput placeholder="Nome" style={styles.input} value={userSignUp.nome2} onChangeText={(nome2) => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, nome2 } })} />
                <Icon name="person-outline" style={styles.inputIcon} />
              </View>
              <View>
                <TextInput placeholder="E-Mail" keyboardType="email-address" style={styles.input} value={userSignUp.email2} onChangeText={(email2) => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, email2 } })} />
                <Icon name="mail-outline" style={styles.inputIcon} />
              </View>
            </>
          )}
          {userSignUp.group_qnt > 2 && (
          <>
            <AppText>Segundo: </AppText>
            <View>
              <TextInput placeholder="Nome" style={styles.input} value={userSignUp.nome3} onChangeText={(nome3) => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, nome3 } })} />
              <Icon name="person-outline" style={styles.inputIcon} />
            </View>
            <View>
              <TextInput placeholder="E-Mail" keyboardType="email-address" style={styles.input} value={userSignUp.email3} onChangeText={(email3) => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, email3 } })} />
              <Icon name="mail-outline" style={styles.inputIcon} />
            </View>
          </>
          )}
          {userSignUp.group_qnt > 3 && (
          <>
            <AppText>Terceiro: </AppText>

            <View>
              <TextInput placeholder="Nome" style={styles.input} value={userSignUp.nome4} onChangeText={(nome4) => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, nome4 } })} />
              <Icon name="person-outline" style={styles.inputIcon} />
            </View>
            <View>
              <TextInput placeholder="E-Mail" keyboardType="email-address" style={styles.input} value={userSignUp.email4} onChangeText={(email4) => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, email4 } })} />
              <Icon name="mail-outline" style={styles.inputIcon} />
            </View>
          </>
          )}
          <AppButton
            disabled={verifyBlanks()}
            onPress={() => navigation.navigate('Selecione os Objetivos')}
            style={styles.button}
            labelStyle={styles.textButton}
            label="Continuar"
          />
        </View>
      </ScrollView>
    </>
  );
};

export default SignUpGroup;
